import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

export const tooltipContent = style({
  // The transient-overlay layer `Select` and `DropdownMenu` use: it clears a
  // dialog's content (1001), below which a tooltip reads as no tooltip at all.
  zIndex: 1050,
  pointerEvents: "none",
  padding: `${primitiveTokens.sizing["1x"]} ${primitiveTokens.sizing["2x"]}`,
  borderRadius: primitiveTokens.radii.md,
  border: `1px solid ${semanticThemeTokens.divider.color}`,
  background: semanticThemeTokens.dialog.content.background,
  boxShadow: primitiveTokens.colors.shadow.popover,
  color: semanticThemeTokens.dialog.content.textColor,
  fontSize: primitiveTokens.type.xs
});
